import React from 'react';
import { Shield, Lock, Eye, Server } from 'lucide-react';

const EncryptedEmailSection = () => {
  const encryptionFeatures = [
    {
      icon: Shield,
      title: 'Advanced encrypted email system',
      description: 'Encryptofy Mail uses layered encryption technologies and strong security protocols to keep all communications private and fully protected.',
    },
    {
      icon: Lock,
      title: 'Full message encryption coverage',
      description: 'Every message stays encrypted from sender to receiver without interruption throughout its journey.',
    },
    {
      icon: Eye,
      title: 'No data tracking or user profiling',
      description: 'We never scan emails for ads or create user profiles. Your privacy is fully respected and protected.',
    },
    {
      icon: Server,
      title: 'Highly secure global infrastructure',
      description: 'Our servers are hosted in privacy-focused regions with advanced, military-grade physical security measures.',
    },
  ];

  return (
    <section className="py-20 text-white relative overflow-hidden" style={{
      backgroundImage: 'url("/assets/banner-bg-img.jpg")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }}>
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-blue-900/80"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Enterprise-grade email encryption
          </h2>
          <p className="text-xl text-blue-200 max-w-3xl mx-auto">
            Encryptofy Mail uses layered encryption technologies and strong security protocols to keep all communications private and fully protected.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {encryptionFeatures.map((feature, index) => (
            <div
              key={index}
              className="group relative"
            >
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 h-full border border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105 hover:shadow-2xl">
                <div className="mb-6">
                  <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center group-hover:rotate-6 transition-transform duration-300">
                    <feature.icon className="h-7 w-7 text-white" strokeWidth={2.5} />
                  </div>
                </div>
                
                <h3 className="text-xl font-bold mb-3">
                  {feature.title}
                </h3>
                
                <p className="text-blue-200 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-8 py-4">
            <Lock className="h-6 w-6 text-teal-400" />
            <span className="text-lg font-semibold">AES-256 Encryption Standard</span>
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-teal-500 rounded-full filter blur-3xl opacity-10 animate-pulse" style={{ animationDuration: '5s' }}></div>
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl opacity-10 animate-pulse" style={{ animationDuration: '7s' }}></div>
    </section>
  );
};

export default EncryptedEmailSection;